var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content change-charge-window",
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "destroy-on-close": true,
        title: _vm.title,
        width: "1300px",
        "before-close": _vm.cancel
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "config-module": "13011101",
              "row-data": _vm.rowData,
              "min-height": "400px"
            }
          })
        ],
        1
      ),
      _vm.totalCurrencyCharge.arData.length > 0
        ? _c("div", { staticClass: "pagination-wrapper" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "flex-wrap": "wrap",
                  "margin-top": "10px"
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable2")))
                ]),
                _vm.totalCurrencyCharge.arData.length > 0
                  ? _c("charge-currency-total-group", {
                      attrs: {
                        "amount-to-currency": _vm.localCurrency,
                        "data-provider": _vm.totalCurrencyCharge.arData,
                        "data-field": "amount",
                        "rate-field": "exchangeRate",
                        "is-gross-profit": true,
                        type: "ar"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.totalCurrencyCharge.apData.length > 0
        ? _c("div", { staticClass: "pagination-wrapper" }, [
            _c(
              "div",
              {
                style:
                  _vm.totalCurrencyCharge.arData.length > 0
                    ? "display: flex;justify-content: flex-end;flex-wrap: wrap;"
                    : "display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;"
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Payable2")))]),
                _vm.totalCurrencyCharge.apData.length > 0
                  ? _c("charge-currency-total-group", {
                      attrs: {
                        "amount-to-currency": _vm.localCurrency,
                        "data-provider": _vm.totalCurrencyCharge.apData,
                        "data-field": "amount",
                        "rate-field": "exchangeRate",
                        "is-gross-profit": true,
                        type: "ap"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _vm.defaultProperties.editMode === "add"
          ? _c(
              "div",
              { staticStyle: { float: "left", "margin-bottom": "10px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.add }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                ),
                _vm.job && _vm.privilege.copyCharge
                  ? _c(
                      "el-button",
                      {
                        attrs: { id: "btnCopyCharge", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.copyChargeHandler()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("FinanceManage.charge_copyCharge")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.job && _vm.privilege.chargeProject
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "charge_sp7", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.chargeSchemeHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("FinanceManage.charge_sp7")) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { float: "right", "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.saveEvent }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
            ),
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
            )
          ],
          1
        )
      ]),
      _c("copy-charge-dialog", {
        attrs: {
          visible: _vm.copyChargeDialog.visible,
          lob: _vm.copyChargeDialog.lob,
          "is-sea": _vm.copyChargeDialog.isSea,
          job: _vm.job,
          receivable: _vm.copyChargeDialog.receivable,
          "view-source": "ChangeCharge"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyChargeDialog, "visible", $event)
          },
          selectedCopyChargeHandler: function(chargeList) {
            _vm.selectedCopyChargeHandler(chargeList)
          }
        }
      }),
      _c("charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "original-condition": _vm.chargePlanDialog.originalCondition,
          "charge-scheme-is-approved":
            _vm.chargePlanDialog.chargeSchemeIsApproved,
          source: _vm.chargePlanDialog.source,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: function(schemeDetails) {
            _vm.selectedSchemeHandler(schemeDetails)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }